import { useState } from "react";
import { getEncryptedBody, getDecryptedData } from "../../../utils/common";
import { toast } from "react-toastify";

interface UseUpdateVisitV2Props {
  location: any;
  patientData: any;
  userDetails: any;
  editedDetails: any;
  isRewardsAssign: boolean;
  coins: any;
}

const useUpdateVisitV2 = ({
  location,
  patientData,
  userDetails,
  editedDetails,
  isRewardsAssign,
  coins,
}: UseUpdateVisitV2Props) => {
  const [updatingVisit, setUpdatingVisit] = useState(false);

  const updateVisitDetailsV2 = async () => {
    setUpdatingVisit(true);
    try {
      const token = localStorage.getItem("token");
      const secretKey = process.env.REACT_APP_HEALTH_SECRET_KEY || '';

      // Build primary_drugs array with is_free inside
      const selectedPrimaryDrug = editedDetails?.primary_drug || editedDetails?.product_name || location.state?.support_program_drug;
      const primaryDrugs = [
        {
          drug_name: selectedPrimaryDrug,
          is_free: String(
            editedDetails?.is_primary_drug_free !== undefined
              ? editedDetails?.is_primary_drug_free
              : 0
          ), // Ensure string: "0" or "1"
        },
      ];

      // Build secondary_drugs array if any are selected
      // Each drug object should have drug_name and is_free
      // Filter out empty rows and map to clean objects
      const secondaryDrugs =
        editedDetails?.secondary_drugs && editedDetails?.secondary_drugs.length > 0
          ? editedDetails.secondary_drugs
              .filter((drug: any) => drug.drug_name && drug.drug_name !== "")
              .map((drug: any) => ({
                drug_name: drug.drug_name,
                is_free: String(drug.is_free !== undefined ? drug.is_free : 0), // Ensure string
              }))
          : [];
      
      const hasSecondaryDrugs = secondaryDrugs.length > 0;

      // Check if rewards should be assigned from editedDetails (V2 UI sets this)
      const shouldAssignRewards = editedDetails?.isRewardsAssign === true;


      // Build visit_meta_info object with V2 format
      const visitMetaInfo: any = {
        //target_therapy_drug: selectedPrimaryDrug,
        //primary_drugs: primaryDrugs, // is_free is inside each drug object
       // therapy_type: editedDetails?.product_type || location.state?.visitMetaInfo?.therapy_type,
        rewards_assigned: shouldAssignRewards ? 1 : 0,
        // Note: is_primary_drug_free removed - is_free is now inside primary_drugs array
      };

      // Add secondary drugs information if any are selected
      // Each drug object already contains drug_name and is_free
      if (hasSecondaryDrugs) {
        visitMetaInfo.secondary_drugs = secondaryDrugs;
        // Note: is_secondary_drug_free removed - is_free is now inside each drug object
      }

      const body: any = {
        patient_visit_id: location.state?.visitID,
        patient_phone: patientData.contact_no,
        patient_name: patientData.name,
        updated_by: userDetails.health_coach_id,
        visit_meta_info: visitMetaInfo,
        visit_status: "VA",
        // Conditionally add "assign_reward" and related parameters
        // Use editedDetails.isRewardsAssign, NOT the prop!
        ...(shouldAssignRewards
          ? {
              assign_reward: 1,
              assign_reward_params: {
                amount: parseInt(`${coins}00`),
                transactionType: "DOCUMENT_UPLOAD",
                notes: {
                  type: "visit_status_approved",
                },
                patientId: location.state?.patientId,
              },
            }
          : { assign_reward: 0 }),
      };

      console.log("V2 Update Visit Payload:", body);

      const enCryptedBody = getEncryptedBody(body);
      const UpdateVisitDetailsAPI = `${process.env.REACT_APP_API_URL}/api/v8/healthcoach/update_patient_visit`;

      const response = await fetch(UpdateVisitDetailsAPI, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          token: `${token}`,
          health_secret: secretKey,
        },
        body: `${enCryptedBody}`,
      });

      if (!response.ok) {
        throw new Error("Failed to update patient visit");
      }

      const data = await response.json();
      const decryptedData = getDecryptedData(data);
      console.log(decryptedData, "Visit updated successfully.");

      setUpdatingVisit(false);
      return true;
    } catch (error) {
      console.error("Error updating visit:", error);
      toast.error("Failed to update visit. Please try again.");
      setUpdatingVisit(false);
      return false;
    }
  };

  return {
    updatingVisit,
    updateVisitDetailsV2,
  };
};

export default useUpdateVisitV2;
